import React from 'react';
import { Carousel, Button } from 'antd';
import Header from './Header'
import Bottom from './../../api/bottom.jsx'
import './index.less'
import callImg from '../../static/img/lianxi.png'
import wx from '../../static/img/wx.png'
import dianhua from '../../static/img/dianhua.png'
import email from '../../static/img/email.png'
import pay from '../../static/img/pay.png'
import manage from '../../static/img/mange.png'
import zhangdan from '../../static/img/zhangdan.png'
import jiaofei from '../../static/img/jiaofei.png'
import menjin from '../../static/img/menjin.png'
import tingche from '../../static/img/tingche.png'
import baoan from '../../static/img/baoan.png'
import baojie from '../../static/img/baojie.png'
import pingzhi from '../../static/img/pingzhi.png'
import data from '../../static/img/data.png'
import baoshi from '../../static/img/baoshi.png'
import home_banner_cooperation from './../../imgs/home_banner_cooperation.png'
import common_data from './../../api/common_data.js'

export default class index extends React.Component {
    componentDidMount() {
    }
    onChange = (a, b, c) => {

    }
    render() {
        return (<div className='index'>
            <Header history={this.props.history} />
            <div style={{display:'none'}}>
            {setTimeout(()=>{common_data.refs=this.refs;},10)}
            </div>
            <Carousel 
                afterChange={this.onChange} 
                // autoplay
            >
                <div className='bg bg1'></div>
                {/* <div className='bg bg3'></div> */}
            </Carousel>
            <div className='call_wrap'>
                <div className='out_wrap'>
                    <img src={callImg} alt=""/>
                    <span>联系</span>
                    <span>我们</span>
                </div>
                <ul className='inner_wrap'>
                    <li>
                        <img src={dianhua} alt=""/>
                        <p className='text_wrap'>
                            <span>联系电话</span>
                            <span style={{color:'#4D7CFE'}}>4008-893-893</span>
                        </p>
                    </li>
                    <li>
                        <img src={email} alt=""/>
                        <p className='text_wrap'>
                            <span>邮件咨询</span>
                            <span>wyy@colourlife.com</span>
                        </p>
                    </li>
                    <li>
                        <img src={wx} alt=""/>
                        <p className='text_wrap'>
                            <span>在线咨询</span>
                            <span>微信号：colourlife888</span>
                        </p>
                    </li>
                </ul>  
            </div>
            <ul className='product-wrap'>
                <li>
                    <h3 className='cn'>打造自己的线上品牌</h3>
                    <h3 className='en'>Build your own online brand</h3>
                    <div className='product'>
                        <div className='desc'>
                           <ul>
                               <li>
                                   <p>独立物业管理系统</p>
                                   <span>免费注册、认证即可拥有自家独立的物业管理控制台</span>
                               </li>
                               <li>
                                   <p>业主使用便捷</p>
                                   <span>通过微信小程序连接业主，高效安全更智能</span>
                               </li>
                               <li>
                                   <p>拥有自有支付体系</p>
                                   <span>通过支付体系，能享用平台产品及平台连接的物业生态产品</span>
                               </li>
                           </ul>
                          {/* <div className='btn-wrap'>
                            <Button type='primary' style={{marginRight: 24}} >购买整套应用</Button>
                            <Button type="primary" ghost >了解详情</Button>
                          </div> */}
                        </div>
                        <img src={pay} alt=""/>
                    </div>
                </li>
                <li>
                    <h3 className='cn'>帮助物业企业“提升收缴率”</h3>
                    <h3 className='en'>Help property enterprises improve the collection rate</h3>
                    <div className='product'>
                        <img src={zhangdan} alt="" style={{paddingLeft: 80, paddingRight: 0}}/>
                        <div className='desc' style={{paddingLeft: 0, paddingRight: 158}}>
                           
                           <ul>
                               <li>
                                   <p>账单自动生成，轻松解决“忘缴费/缴费不方便”问题</p>
                                   <span>每月账单由收费系统自动生成，并通过线上推送到业主微信，业主可通过线上缴费</span>
                               </li>
                               <li>
                                   <p>物业服务满意度收集</p>
                                   <span>催费系统可了解业主对物业服务的不满，形成带“悬赏”和“打赏”的工单</span>
                               </li>
                               <li>
                                   <p>员工激励</p>
                                   <span>完成物业满意度工单，“悬赏”和“打赏”的奖金秒到员工账户</span>
                               </li>
                           </ul>
                          {/* <div className='btn-wrap'>
                            <Button type='primary' style={{marginRight: 24}} >购买整套应用</Button>
                            <Button type="primary" ghost >了解详情</Button>
                          </div> */}
                        </div>
                       
                    </div>
                </li>
                <li>
                    <h3 className='cn'>提升物业管理品质</h3>
                    <h3 className='en'>Improve the quality of property management</h3>
                    <div className='product'>
                        <div className='desc'>
                           <ul>
                               <li>
                                   <p>搭建工单/订单体系</p>
                                   <span>将物业管理的各项工作（清洁、维修、客服等）量化，形成工单/订单</span>
                               </li>
                               <li>
                                   <p>员工“多劳多得”</p>
                                   <span>员工完成工单/订单工作，由质检或业主评价，满意后即时支付劳动报酬</span>
                               </li>
                               <li>
                                   <p>数据有迹可循</p>
                                   <span>可根据时间、空间点及内容对准工单/订单，追溯到员工，控制员工的费用支付（或考核劳动者的绩效），促进其工作改进</span>
                               </li>
                           </ul>
                          {/* <div className='btn-wrap'>
                            <Button type='primary' style={{marginRight: 24}} >购买整套应用</Button>
                            <Button type="primary" ghost >了解详情</Button>
                          </div> */}
                        </div>
                        <img src={manage} alt=""/>
                    </div>
                </li>
                <li>
                    <h3 className='cn'>提高超过30个社区场景的产品</h3>
                    <h3 className='en'>Improve the quality of property management</h3>
                    <div className=' product-list'>
                        <div className='desc-list'>
                           <ul>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${ jiaofei})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>缴费</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${ menjin})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>门禁</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${ tingche})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>停车</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${ baoan})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>保安</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                           </ul>
                           <ul>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${ baojie})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>保洁</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${pingzhi})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>品质管控</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${data})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>数据分析</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                              <li>
                                  {/* <img src={jiaofei} alt=""/> */}
                                  <div style={{backgroundImage: `url(${baoshi})`}} className='img'></div>
                                  <div className='bottom-wrap'>
                                      <p>报事报修</p>
                                      {/* <Button type='primary'>了解更多</Button> */}
                                  </div>
                              </li>
                           </ul>
                        </div>
        
                    </div>
                </li>
            </ul>
           
            <div className="partner w" ref='partner'>
                {/* 合作伙伴 */}
                <h3 style={{margin:0}}>合作伙伴</h3>
                <p style={{margin:0}}>cooperative partner</p>
                <div className="img">
                    <img src={home_banner_cooperation} width='100%' alt="" />
                </div>
            </div>
            <Bottom></Bottom>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/index/index.jsx